var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('horizontal-stepper',{ref:"formWizard",attrs:{"steps":_vm.demoSteps,"locale":"es"},on:{"completed-step":_vm.completeStep,"active-step":_vm.isStepActive,"stepper-finished":_vm.completeWizard}})}
var staticRenderFns = []

export { render, staticRenderFns }